import React from 'react';
import RadioML from './RadioML';

export default (props) => {
  return <RadioML {...props} />;
};
